<template>
  <div class="maintenance">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-xl-3">
            <div class="card card-h-100">
              <div class="card-body p-0">
                <div>
                  <div class="creat-btn">
                    <button
                      class="btn btn-primary w-100 mb-3"
                      @click="handleAdd()"
                    >
                      <i class="mdi mdi-plus"></i>
                      新建维修任务
                    </button>
                  </div>
                  <div class="scheduled">
                    <flat-pickr v-model="smCalendarDate" :config="dateConfig">
                    </flat-pickr>
                    <button
                      class="btn w-100 piker-btn"
                      @click="handleToToday()"
                    >
                      今天
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-9">
            <div class="card card-h-100">
              <div class="card-body equipment" style="position: relative">
                <FullCalendar ref="calendar" :options="calendarOptions" />
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
    <AddForm
      v-if="isShowAddForm"
      :singleData="singleData"
      :formType="formType"
      :date="date"
      v-model:isShowAddForm="isShowAddForm"
      @handleGetRepairRecords="handleGetRepairRecords"
      @handleAlert="handleAlert"
    ></AddForm>
    <EditForm
      v-if="isShowReportForm"
      :formType="formType"
      :singleData="singleData"
      :date="date"
      v-model:isShowReportForm="isShowReportForm"
      @handleEdit="handleEdit"
      @handleDelete="handleDelete"
      @handleStatus="handleStatus"
      @handleAlert="handleAlert"
    ></EditForm>
    <MessageAlert
      :alertInfo="alertInfo"
      v-if="formValidataAlert"
    ></MessageAlert>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import "@fullcalendar/core/vdom";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import FullCalendar from "@fullcalendar/vue3";
import moment from "moment";
import _ from "loadsh";
import AddForm from "./components/RepairAddForm.vue";
import EditForm from "./components/RepairEditForm.vue";
import MessageAlert from "@/components/common/MessageAlert";
import {
  getRepairTasks,
  deleteRepairTasks,
  editRepairTasks,
} from "@/service/index.js";
export default {
  data() {
    return {
      calendarOptions: {
        timeZone: "local",
        locale: "zh-cn",
        plugins: [
          dayGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        themeSystem: "bootstrap",
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,listMonth",
        },
        buttonText: {
          today: "今天",
          month: "月视图",
          listMonth: "视图列表",
        },
        customButtons: {
          prev: {
            text: "prev",
            click: () => {
              var da = moment(this.$refs.calendar.getApi().getDate()).subtract(
                3,
                "months"
              );

              const e = moment(this.$refs.calendar.getApi().getDate())
                .startOf("month")
                .format("YYYY-MM-DD");
              const s = this.moment(da).endOf("month").format("YYYY-MM-DD");
              var movetype = true;
              this.date = {
                s,
                e,
                movetype,
              };
              this.handleGetRepairRecords(this.date);
              this.$refs.calendar.getApi().prev();
            },
          },
          next: {
            text: "next",
            click: () => {
              var da = moment(this.$refs.calendar.getApi().getDate()).add(
                2,
                "months"
              );

              const s = moment(this.$refs.calendar.getApi().getDate())
                .startOf("month")
                .format("YYYY-MM-DD");
              const e = this.moment(da).endOf("month").format("YYYY-MM-DD");
              var movetype = true;

              this.date = {
                s,
                e,
                movetype,
              };
              this.handleGetRepairRecords(this.date);
              this.$refs.calendar.getApi().next();
            },
          },
          today: {
            text: "今天",
            click: () => {
              const s = this.moment().startOf("month").format("YYYY-MM-DD");
              const e = this.moment().endOf("month").format("YYYY-MM-DD");
              this.date = {
                s,
                e,
              };
              this.handleGetRepairRecords(this.date);
              this.$refs.calendar.getApi().today();
            },
          },
        },
        noEventsContent: "没有要显示的事件",
        windowResize: () => {
          this.getInitialView();
        },
        initialView: this.getInitialView(),
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        dateClick: this.dateClicked,
        eventClick: this.editEvent,
        events: [],
        eventDidMount: (info) => {
          if (
            info.view.type === "dayGridMonth" &&
            info.event._def.extendedProps.status === "done"
          ) {
            let titleEl = info.el.getElementsByClassName("fc-event-title")[0];
            titleEl.style.textDecoration = "line-through";
            titleEl.style.opacity = "0.5";
          }
          if (info.view.type == "listMonth") {
            let btn = document.createElement("td");
            let i = document.createElement("i");
            btn.append(i);
            if (info.event._def.extendedProps.status === "done") {
              i.className =
                "statusbtn fs-20 ri-checkbox-circle-fill text-success";
              let titleEl = info.el.getElementsByClassName(
                "fc-list-event-title"
              )[0];
              let dotEl =
                info.el.getElementsByClassName("fc-list-event-dot")[0];
              titleEl.style.textDecoration = "line-through";
              titleEl.style.opacity = "0.5";
              dotEl.style.opacity = "0.5";
            } else {
              i.className =
                "statusbtn fs-20 ri-checkbox-circle-fill text-muted";
            }
            btn.style.height = "30px";
            btn.style.width = "30px";
            btn.style.zIndex = "9999";
            btn.style.cursor = "pointer";

            btn.addEventListener("click", this.changeTypeclick, true);

            info.el.append(btn);
            let ths = document.querySelectorAll(".fc-list-day th");
            ths.forEach((th) => {
              th.getAttributeNode("colspan").value = 4;
            });
          }
        },
      },
      dateConfig: {
        inline: true,
        altFormat: "Y-m-d", //选择时显示的时间
        altInput: false,
        dateFormat: "Y-m-d",
      },
      searchStatus: null,
      date: {}, //查询维修记录接口参数-日历面板
      startDate: null,
      smCalendarDate: moment().format("YYYY-MM-DD"),
      isShowAddForm: false,
      formType: "add",
      singleData: {},
      alertInfo: {
        variant: "danger",
        content: "Request failed, please try again!",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      isShowReportForm: false,
      isShowAlert: false,
      changepamtype: false,
    };
  },
  mounted() {
    const s = moment().subtract(1, "M").startOf("month").format("YYYY-MM-DD");
    const e = moment().add(1, "M").endOf("month").format("YYYY-MM-DD");
    this.recentDate = this.date = {
      s,
      e,
    };
    this.handleGetRepairRecords(this.date);
  },
  methods: {
    moment,
    getInitialView() {
      if (window.innerWidth <= 768) {
        return "listMonth";
      } else {
        return "dayGridMonth";
      }
    },
    handleGetRepairRecords(date) {
      let params = {
        equipment_id: this.$route.query.equip_id,
        start_date: date.s,
        end_date: date.e,
      };
      getRepairTasks(params)
        .then((res) => {
          if (
            res &&
            _.get(res, ["meta", "code"]) == 200 &&
            res.payload &&
            res.payload.data
          ) {
            this.calendarOptions.events = res.payload.data;
            this.calendarOptions.events.length &&
              this.calendarOptions.events.map((item) => {
                item.title = item.equipment_snapshot;
                item.start = item.repair_at;
                item.className = "text-info text-start fs-14";
                if (item.end_date) {
                  item.end = item.end_date + "";
                }
                if (item.status === "done") {
                  item.className = "text-info text-start fs-14";
                }
              });
          }
        })
        .catch((err) => {
          this.handleAlert("danger", err.message || "请求失败，请重试");
        });
    },
    handleEdit(data) {
      this.singleData = _.cloneDeep(data);
      this.formType = "edit";
      this.isShowAddForm = true;
    },
    handleToToday() {
      this.smCalendarDate = moment().format("YYYY-MM-DD");
    },
    dateClicked(info) {
      let date = moment(info.date).format("YYYY-MM-DD");
      this.handleAdd(date);
    },
    handleDelete(id) {
      Swal.fire({
        title: "是否确认?",
        text: "您将无法还原此操作!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteRepairTasks(id)
            .then((res) => {
              if (res && _.get(res, ["meta", "code"]) == 200) {
                Swal.fire({
                  text: this.$t('base.delete_success'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: this.$t('base.ok'),
                });
                this.isShowReportForm = false;
                this.handleGetRepairRecords(this.date);
              }
            })
            .catch((err) => {
              Swal.fire("Failed!", err.message || "删除失败，请重试!", "error");
            });
        }
      });
    },
    //点击日历面板中维修记录项
    editEvent(info) {
      let data = info.event._def.extendedProps;
      if (
        this.changepamtype &&
        info.jsEvent.target.classList[0] === "statusbtn"
      ) {
        let status = data.status == "pending" ? "done" : "pending";
        let statusParams = {
          repair_at: data.repair_at,
          equipment_id: data.equipment_id,
          equipment_snapshot: data.equipment_snapshot,
          end_date: status == "done" ? moment().format("YYYY-MM-DD") : null,
          status: status,
        };
        let id = info.event._def.publicId;
        this.handleStatus("list", id, statusParams);
      } else {
        this.singleData = _.cloneDeep({
          ...data,
          properties: JSON.parse(data.properties),
          id: info.event._def.publicId,
        });
        this.isShowReportForm = true;
      }
    },
    handleAdd(date) {
      this.startDate = date || this.smCalendarDate;
      this.singleData = {
        equipment_id: "",
        equipment_snapshot: "",
        description: "",
        attachments: [],
        operator: "",
        repair_at: this.startDate,
        status: "pending",
        properties: {
          suspendedCheck: false,
          downTime: [0, 0, 0],
          solution: "",
        },
      };
      this.formType = "add";
      this.isShowAddForm = true;
    },
    handleStatus(flag, id, params) {
      editRepairTasks(id, params)
        .then((res) => {
          if (res && _.get(res, ["meta", "code"]) == 200 && res.payload) {
            this.handleAlert(
              "success",
              "更新成功!",
              "ri-check-double-line",
              1000
            );
            this.handleGetRepairRecords(this.date);
            if (flag == "list") {
              // this.changepamtype = false;
            } else if (flag == "report") {
              this.isShowReportForm = false;
            }
          }
        })
        .catch((err) => {
          this.handleAlert(
            "danger",
            err.message || "Request failed, please try again!"
          );
        });
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.formValidataAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.formValidataAlert = false;
      }, duration);
    },
  },
  components: {
    FullCalendar,
    AddForm,
    EditForm,
    MessageAlert,
  },
};
</script>

<style scoped lang='scss'>
:deep(.fc-event) {
  background-color: transparent !important;
  cursor: pointer !important;
  .fc-daygrid-event-dot {
    display: block !important;
    border-color: #3788d8 !important;
  }
  .fc-event-title {
    flex-grow: 0 !important;
  }
  .fc-event-time,
  .fc-list-event-time {
    display: none !important;
  }
}
:deep(.fc) {
  td {
    vertical-align: middle !important;
  }
  .fc-list-event-title a {
    color: #212529 !important;
  }
}
:deep(.fc-list-day-cushion) {
  background: rgba(53, 119, 241, 0.1);
  a {
    color: #299cdb;
  }
}

.scheduled {
  .flatpickr-input {
    display: none;
  }
  .flatpickr-months {
    display: none !important;
  }
}
.piker-btn {
  background-color: #fff;
  border-top: 1px solid #e9ebec;
  color: #6691e7;
}
.creat-btn {
  padding: 10px 10px 0;
}
</style>
